import script from "./BalVerticalSteps.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalVerticalSteps.vue?vue&type=script&lang=ts&setup=true"

import "./BalVerticalSteps.vue?vue&type=style&index=0&id=44435338&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44435338"]])

export default __exports__